var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactUs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1.80341V3.49091C0.5 4.12372 0.992188 4.61591 1.625 4.61591H2.1875H3.875V1.80341C3.875 0.889343 3.10156 0.115906 2.1875 0.115906C1.23828 0.115906 0.5 0.889343 0.5 1.80341ZM4.4375 0.115906C4.78906 0.608093 5 1.17059 5 1.80341V12.4909C5 13.7565 5.98438 14.7409 7.25 14.7409C8.48047 14.7409 9.5 13.7565 9.5 12.4909V12.3151C9.5 11.1901 10.4141 10.2409 11.5391 10.2409H17.375V3.49091C17.375 1.62762 15.8633 0.115906 14 0.115906H4.4375ZM16.8125 15.8659C18.957 15.8659 20.75 14.1081 20.75 11.9284C20.75 11.6472 20.4688 11.3659 20.1875 11.3659H11.5391C11.0469 11.3659 10.625 11.7878 10.625 12.3151V12.4909C10.625 14.3542 9.11328 15.8659 7.25 15.8659H13.4375H16.8125Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default ForwardRef;